


































import Component from 'vue-class-component';
import { Prop, VModel } from 'vue-property-decorator';
import Vue from 'vue';
import { CustomerAutocompleteModel } from '@/context/customer/model/CustomerAutocompleteModel';
import { customerApi } from '@/context/customer/api/CustomerApi';

@Component({})
export default class CustomerAutocompleteTS extends Vue {
  @VModel({ type: CustomerAutocompleteModel })
  model!: CustomerAutocompleteModel;
  @Prop({
    default: "",
    type: String
  })
  queryParam!: string;
  @Prop({
    type: Array,
    default: () => []
  })
  rules: [] = [];
  @Prop({
    type: Boolean,
    default: false
  })
  multiple: boolean = false;
  @Prop({
    type: Boolean,
    default: false
  })
  returnObject: boolean = false;
  items: CustomerAutocompleteModel[] = [];
  loading = false;
  search = "";

  mounted(): void {
    this.loadItems();
  }

  async loadItems(): Promise<void> {
    this.loading = true;
    this.items = await customerApi.autocomplete("", {});
    this.loading = false;
  }
}
